export const PROFILE = {
  admin: 'admin',
  financial: 'financial',
  sales: 'sales',
  operations: 'operations',
  head_operation: 'head_operation'
};
